.chat-icon {
  position: relative;

  .title {
    padding-right: 5px;
  }
}

.unread-indicator {
  position: absolute;
  height: 8px;
  width: 8px;
  background: var(--color-primary-darken-10);
  border-radius: 50%;
  top: -2px;
  right: -2px;
  display: block;

  &.hidden {
    display: none;
  }
}

.simplero-chat {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 250;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  visibility: visible;
  opacity: 1;

  &--closed {
    visibility: hidden;
    opacity: 0;
    transition: all 0.1s linear;
  }

  .simplero-chat__modal {
    background: white;
    border-radius: 20px;
    position: relative;
    width: 80vw;
    max-width: 800px;
    height: 80vh;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;

    @media (max-width: 1300px) {
      width: 95vw;
      max-width: 95%;
    }
  }

  .simplero-chat__close {
    position: absolute;
    right: 10px;
    top: 10px;
    appearance: none;
    background: none;
    padding: 5px 10px;
    line-height: 1;
    border: none;
    z-index: 99999;
    cursor: pointer;

    svg {
      path {
        fill: #334155;
      }
    }
  }

  .simplero-chat__iframe-container {
    width: 100%;
    height: 100%;

    iframe {
      width: 100%;
      height: 100%;
    }
  }
}

.site-header__nav-chat.mobile-only {
  a {
    padding-left: calc(var(--header-padding-horizontal) - 3px) !important;
  }

  svg {
    display: none;
  }
}

.site-header__nav-chat.mobile-hidden {
  a {
    padding-left: calc(var(--header-padding-horizontal) - 3px) !important;
  }

  .title {
    display: none;
  }
}

.site-header__left-nav-chat.mobile-only {
  a {
    padding-left: calc(var(--header-padding-horizontal) - 3px) !important;
  }

  svg {
    width: 12px;
    top: -1px;
    position: relative;
  }
}

.site-header__left-nav-chat.mobile-hidden {
  list-style-type: none;
  padding: 12px 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);

  a {
    display: block;
  }

  svg {
    width: 12px;
    top: -1px;
    position: relative;
  }

  .title {
    margin-left: 2px;
  }
}
